// extracted by mini-css-extract-plugin
export default {"overlay":"Qs-z","bodyOpen":"Rs-z","content":"Ss-z","header":"Ts-z","close":"Us-z","closeNoHeading":"Vs-z"};